/**
 * contact.jsx
 * import axios for server calls
 * import button from react boostrap for styling
 * import Form form react boostrap for form and stylign
 * import ErrorMessage for displaying error messages
 * import SuccMessage for displaying succ messages
 * import Row and Col form react bootstrap for organization of display
 */
import React, {useState} from 'react';
import axios from "axios"; //used for making request to server
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import '../../style/contactPage.css';
import ErrorMessage from './ErrorMessage'; //used to display error messges from server
import SuccMessage from './succMessage'; //used to display success messages from server
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/**
 * function Contact() is used to send a message from the user to the dev team
 * of the website. 
*/
function Contact() {
    const [errorMessage, setErrorMessage] = useState(null);
    const [succMessage, setSuccMessage] = useState(null);

    /**
     * function contactUs(e) is used to take in the email
     * and message of the user, then the data to the server for processing.
     */
    async function contactUs(e) {
        e.preventDefault();
        const email = e.target.contactPage.value;
        const message = e.target.contactMessage.value;

        const contactUsData = {
            email: email,
            message: message
        }
        //try to send contact email, if req fails, displays error message
        try {
            const response = await axios.post("https://link2rsvp.herokuapp.com/contactus", contactUsData);
            setSuccMessage(response.data.message);
        } catch (err) {
            if (err.response) {
                if (err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
        }
        //clearing form inputs
        document.getElementById('contactPage').value = '';
        document.getElementById('contactMessage').value='';
        return;
    }

    return (
        <div>
            {
                succMessage && (
                    <SuccMessage
                    message={succMessage}
                    clear={() => setSuccMessage(null)}
                    />
                )
            }
            {
                errorMessage && (
                    <ErrorMessage
                    message={errorMessage}
                    clear={() => setErrorMessage(null)}
                    />
                )
            }
            
            <div id="contact">
                <Row>
                    <Col>
                        <h3>Contact LINK2RSVP</h3>
                        <p>If you have any questions or concerns, please let us know.</p>
                        <Form onSubmit={contactUs}>
                            <Form.Group className="mb-3">
                                <label htmlFor="contactPage">Please enter your email:</label>
                                <Form.Control
                                id="contactPage"
                                type="email"
                                name="contactPage"
                                placeholder="email"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <label htmlFor="contactMessage">Please enter your message to us:</label>
                                <Form.Control
                                id="contactMessage"
                                name="contactMessage"
                                placeholder="enter your message here"
                                as="textarea"
                                row="5"
                                />
                            </Form.Group>
                            <Button type="submit"
                            variant="secondary"
                            id="contact-btn"
                            style={{backgroundColor: "#890E32"}}
                            >Send</Button>
                        </Form>
                    </Col>
                    <Col>
                        <h4>LINK2RSVP</h4>
                        <br></br>
                        <span role="img" aria-labelledby="pandal"><p>&#9993; poc.demo.email@gmail.com</p></span>
                        <span role="img" aria-labelledby="pandal"><p>&#9990; +0-000-000-0000</p></span>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Contact;